import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import ModalTransitions from './ModalTransitions';
import stylesJS from './styles';
import styles from './styles.module.scss';

function UTModal({
  isOpen,
  onRequestClose,
  contentLabel,
  title,
  children,
  acceptButton,
  cancelButton,
  imageModal,
  styleContainer = {}
}) {
  const containerStyle = imageModal ? stylesJS.contentImage : stylesJS.contentForm;

  const modalStyle = {
    overlay: { ...stylesJS.overlayStyle, ...styleContainer.overlay },
    content: { ...containerStyle, ...styleContainer.content }
  };

  return (
    <div>
      <ModalTransitions />
      <Modal
        style={modalStyle}
        isOpen={isOpen}
        contentLabel={contentLabel}
        onRequestClose={onRequestClose}
        ariaHideApp={false}
        closeTimeoutMS={300}
      >
        <div style={stylesJS.container}>
          {isOpen && title && (
            <div className={styles.header}>
              <UTLabel large bold white style={stylesJS.title}>
                {title}
              </UTLabel>
            </div>
          )}
          <div style={stylesJS.content}>{isOpen && children}</div>
          {(acceptButton || cancelButton) && isOpen && (
            <div style={stylesJS.footer}>
              {cancelButton && (
                <UTButton
                  secondary
                  onPress={cancelButton.onPress}
                  className={`${styles.button} ${cancelButton.className}`}
                >
                  {cancelButton.text}
                </UTButton>
              )}
              {acceptButton && (
                <UTButton
                  onPress={acceptButton.onPress}
                  disabled={acceptButton.disabled}
                  autoFocus
                  className={`${styles.button} ${acceptButton.className}`}
                >
                  {acceptButton.text}
                </UTButton>
              )}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}

const buttonPropTypes = PropTypes.shape({
  text: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  disabled: PropTypes.bool
});

UTModal.propTypes = {
  ...Modal.propTypes,
  title: PropTypes.string,
  acceptButton: buttonPropTypes,
  cancelButton: buttonPropTypes
};

export default Radium(UTModal);
